import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

// ✅ Async Thunks

// Fetch all categories
export const fetchCategories = createAsyncThunk(
  "categories/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/categories");
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Something went wrong" });
    }
  }
);


// Create new category
export const createCategory = createAsyncThunk(
  "categories/create",
  async (categoryData, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/create-category", categoryData, {
        withCredentials: true,
      });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Something went wrong" });
    }
  }
);


// Update category
export const updateCategory = createAsyncThunk(
  "categories/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/update-category/${id}`, data, { withCredentials: true });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Something went wrong" });
    }
  }
);

// Delete category
export const deleteCategory = createAsyncThunk(
  "categories/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/delete-category/${id}`, { withCredentials: true });
      return { ...data, id };
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Something went wrong" });
    }
  }
);

// Initial State
const initialState = {
  categories: [],
  loading: false,
  error: null,
  success: null,
};

const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    clearCategoryMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) state.categories = action.payload.data;
        else state.error = action.payload.message;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message;
      })

      // Create
      .addCase(createCategory.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.categories.unshift(action.payload.data);
          state.success = action.payload.message;
        } else {
          state.error = action.payload.message;
        }
      })
      .addCase(createCategory.rejected, (state, action) => {
        state.error = action.payload?.message;
      })

      // Update
      .addCase(updateCategory.fulfilled, (state, action) => {
        if (action.payload.success) {
          const index = state.categories.findIndex((cat) => cat._id === action.payload.data._id);
          if (index !== -1) state.categories[index] = action.payload.data;
          state.success = action.payload.message;
        } else {
          state.error = action.payload.message;
        }
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.error = action.payload?.message;
      })

      // Delete
      .addCase(deleteCategory.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.categories = state.categories.filter((cat) => cat._id !== action.payload.id);
          state.success = action.payload.message;
        } else {
          state.error = action.payload.message;
        }
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.error = action.payload?.message;
      });
  },
});

export const { clearCategoryMessages } = categorySlice.actions;
export default categorySlice.reducer;
